<template>
    <section v-if="issues.length" class="alert alert-danger timesheet-text-quality" role="alert" aria-live="polite">
        <strong>Табель нельзя отправить: исправьте характеристики и пояснения КТУ</strong>
        <p class="mb-2">Проблемных полей: {{ issues.length }}. Откройте указанное поле и добавьте конкретные факты. Введённый текст сохранён.</p>
        <article v-for="issue in issues" :key="issue.line_id + ':' + issue.field_key" class="quality-item">
            <div>
                <EmployeeLink :employee-id="issue.employee_id" :fallback="issue.employee_name" compact open-in-panel />
                <strong class="d-block">{{ issue.field_label }}</strong>
                <blockquote v-if="issue.value" class="user-quote my-2">{{ issue.value }}</blockquote>
                <p class="mb-1">{{ issue.message }} {{ issue.help }}</p>
            </div>
            <b-button size="sm" variant="outline-danger" :disabled="!editable" @click="$emit('fix', issue)">Исправить поле</b-button>
        </article>
    </section>
</template>
<script>
import EmployeeLink from '@/components/EmployeeLink.vue';
export default {name: 'TimesheetTextQualityNotice', components: {EmployeeLink}, props: {issues: Array, editable: Boolean}};
</script>
<style scoped>
.quality-item { display: flex; align-items: flex-start; gap: 12px; padding: 12px 0; border-top: 1px solid rgba(120, 40, 40, .15); }
.quality-item > div { flex: 1; min-width: 0; overflow-wrap: anywhere; }
.user-quote { white-space: pre-wrap; }
@media (max-width: 600px) { .quality-item { flex-direction: column; } }
</style>
